import { gqlMutate, gqlQuery } from '@hapana/shared/web/services/requests.service'

import { ME_CORE_MOCKED_RESPONSE } from '../mocks/me.mock'

import * as mutations from './graphql/me.mutations'
import { meQuery, meProfileImageQuery } from './graphql/me.queries'

const ME_QUERY_KEY = 'ME_QUERY'

export const getMe = gqlQuery({
  key: ME_QUERY_KEY,
  query: meQuery,
  mockResponse: ME_CORE_MOCKED_RESPONSE,
  options: {
    isV1: false,
  },
})

export const updateProfileImage = ({ format }) =>
  gqlMutate({
    mutation: mutations.updateProfileImage,
    variables: {
      format,
    },
    options: {
      isV1: false,
    },
  }).then((response) => response.me.updateProfileImage)

export const deleteProfileImage = () =>
  gqlMutate({
    mutation: mutations.deleteProfileImage,
    options: {
      isV1: false,
    },
  }).then((response) => response.deleteMyProfileImage)

export const updateUserName = ({ firstName, lastName }) =>
  gqlMutate({
    mutation: mutations.updateUserName,
    variables: {
      meInput: {
        firstName,
        lastName,
      },
    },
    options: {
      isV1: false,
    },
  })

export const updateEmail = ({ email }) =>
  gqlMutate({
    mutation: mutations.updateEmail,
    variables: {
      meInput: {
        email,
      },
    },
    options: {
      isV1: false,
    },
  })

export const getMeProfileImage = gqlQuery({
  key: ['ME_PROFILE_IMAGE'],
  query: meProfileImageQuery,
  options: {
    isV1: false,
  },
})

export const invalidateProfileImageCache = () =>
  gqlMutate({
    mutation: mutations.invalidateProfileImageCache,
    options: {
      isV1: false,
    },
  })
